;(function () {
  'use strict'

  angular
    .module('admin.storyboard_event.service', [])
    .factory('StoryboardEventService', StoryboardEventService)

  /** @ngInject */
  function StoryboardEventService($http, $q, API) {
    function list() {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/configurations').success(defered.resolve)

      return defered.promise
    }

    function set(key, model) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'admin/configurations/' + key, model).success(defered.resolve)

      return defered.promise
    }

    function get() {
      var defered = $q.defer()

      $http.get(API.API_URL + 'storyboard_events/config').success(defered.resolve)

      return defered.promise
    }

    return {
      list,
      get,
      set,
    }
  }
})()
